module.exports = __webpack_public_path__ + "static/media/Single Matting Text and Logo.ae7337a0.png";